import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Divider } from 'primereact/divider'

import { LinkButton } from '../../../linkbutton/LinkButton'
import { FooterDialog } from '../../shared'

export const Footer: React.FC = () => {
  const [dialogVisible, setDialogVisible] = useState(false)
  const [header, setHeader] = useState<string | null>(null)
  const [filename, setFilename] = useState<string | null>(null)
  const [isTenantLevel, setIsTenantLevel] = useState(false)
  const { t } = useTranslation()

  const spacer = <span className="text-sm text-200 mx-3">|</span>

  return (
    <>
      <footer className="flex flex-column align-items-center">
        <Divider className="mb-4" />
        <div className="flex align-items-center flex-wrap">
          <LinkButton
            className="text-sm text-300"
            onClick={() =>
              window.open(
                'https://nttdata-solutions.com/de/impressum/',
                '_blank',
                'noreferrer',
              )
            }
          >
            {t('footer.content.imprint')}
          </LinkButton>

          {spacer}

          <LinkButton
            className="text-sm text-300"
            onClick={() => {
              setHeader(t('footer.content.copyright'))
              setFilename('copyright.md')
              setDialogVisible(true)
              setIsTenantLevel(true)
            }}
          >
            {t('footer.content.copyright')}
          </LinkButton>

          {spacer}

          <LinkButton
            className="text-sm text-300"
            onClick={() => {
              setHeader(t('footer.content.dataProtection'))
              setFilename('data-protection.md')
              setDialogVisible(true)
              setIsTenantLevel(false)
            }}
          >
            {t('footer.content.dataProtection')}
          </LinkButton>

          {spacer}

          <LinkButton
            className="text-sm text-300"
            onClick={() => {
              setHeader(t('footer.content.termsOfUse'))
              setFilename('terms-of-use.md')
              setDialogVisible(true)
              setIsTenantLevel(false)
            }}
          >
            {t('footer.content.termsOfUse')}
          </LinkButton>

          {spacer}

          <LinkButton
            className="text-sm text-300"
            onClick={() => {
              setHeader(t('footer.content.contact'))
              setFilename('contact.md')
              setDialogVisible(true)
              setIsTenantLevel(false)
            }}
          >
            {t('footer.content.contact')}
          </LinkButton>
        </div>
      </footer>

      {filename && (
        <FooterDialog
          visible={dialogVisible}
          setVisible={setDialogVisible}
          header={header}
          filename={filename}
          isLocalfile={isTenantLevel}
        />
      )}
    </>
  )
}
